import { ModelConfig, CameraPreset } from '../types/models';
import { ANIMATION_MODE_CAMERAS, DEFAULT_BACKGROUND_COLOR, DEFAULT_AMBIENT_LIGHT_INTENSITY, DEFAULT_DIRECTIONAL_LIGHTS, DEFAULT_CAMERA_FOV, DEFAULT_CAMERA_NEAR, DEFAULT_CAMERA_FAR } from '../constants/defaults';

/**
 * Load model configuration from models.json
 */
export async function loadModelConfig(modelKey: string): Promise<ModelConfig | null> {
  try {
    const response = await fetch('/models.json');
    const configs: Record<string, ModelConfig> = await response.json();
    return configs[modelKey] || null;
  } catch (error) {
    console.warn(`Failed to load config for model "${modelKey}":`, error);
    return null;
  }
}

/**
 * Create a default configuration from a custom GLB URL
 */
export function createConfigFromGlbUrl(glbUrl: string, background?: string): ModelConfig {
  return {
    name: 'Custom Model',
    modelPath: glbUrl,
    background: background || DEFAULT_BACKGROUND_COLOR,
    defaultAnimation: 'auto',
    animations: {
      auto: {
        camera: { ...ANIMATION_MODE_CAMERAS.auto },
      },
      step_by_step: {
        camera: { ...ANIMATION_MODE_CAMERAS.step_by_step },
      },
      exploded_view: {
        camera: { ...ANIMATION_MODE_CAMERAS.exploded_view },
      },
    },
    lighting: {
      ambient: DEFAULT_AMBIENT_LIGHT_INTENSITY,
      directional: [...DEFAULT_DIRECTIONAL_LIGHTS],
    },
    camera: {
      fov: DEFAULT_CAMERA_FOV,
      near: DEFAULT_CAMERA_NEAR,
      far: DEFAULT_CAMERA_FAR,
    },
  };
}
